export default {"src":"/app/_next/static/media/boxes_for_dark_themes.78d7ce7a.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};